import React from 'react';
import { Box, Typography } from '@mui/material';

const SectionHeading = ({ title, subtitle }) => {
  return (
    <Box sx={{ textAlign: 'center', mb: 6 }}>
      <Typography variant="h3" component="h2" gutterBottom>
        {title}
      </Typography>
      {subtitle && (
        <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 700, mx: 'auto' }}>
          {subtitle}
        </Typography>
      )}
    </Box>
  );
};

export default SectionHeading;